import styles from './BackButton.module.css';

function BackButton({ onClick, label = "← Back to Budget Tracker" }) {
  return (
    <button
      onClick={onClick}
      className={styles.backButton}
    >
      {label}
    </button>
  );
}

export default BackButton;
